<div class="flex flex-col w-full h-full relative z-[9999999] ">
  <div class="gap-[24px] flex flex-row h-[74px] shrink-0 justify-start items-center pl-[32px] pr-[32px] pt-[16px] pb-[16px] bg-[#ffffffff] border-b-[2px] w-[100%] relative">
    <a routerLink="/programs" class="cursor-pointer focus:outline-none" aria-label="BakerRipley programs home">
      <img src="assets/icons/BakerriplyTextLogo.svg" alt="BakerRipley logo" loading="eager" fetchpriority="high" decoding="async" class="w-[128px] h-[24px] shrink-0 justify-start items-start bg-[#ffffffff]" />
    </a>
  
    <div class="w-[100%] h-[10px] shrink-0 justify-start items-start grow basis-0"></div>
    <div class="gap-[8px] flex flex-row shrink-0 justify-end items-center">

      <!-- Location chip: click to switch centers without signing out -->
      <button
        *ngIf="selectedLocationName"
        type="button"
        class="flex flex-row items-center gap-[5px] bg-[#FFF3EA] border border-[#FFCBA4] rounded-full px-[12px] py-[6px] mr-[8px] cursor-pointer hover:bg-[#FFE8D6]"
        title="Switch center"
        aria-label="Switch working center"
        [disabled]="isRefreshingLocations"
        (click)="openLocationSwitcher($event)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[14px] h-[14px] text-[#ff6900ff] shrink-0" viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-2.034 3.048-4.152 3.048-6.327C19.337 8.27 16.026 5 12 5s-7.337 3.27-7.337 7.001c0 2.175 1.104 4.293 3.048 6.327a19.579 19.579 0 002.683 2.282 16.974 16.974 0 001.144.742zM12 13.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" clip-rule="evenodd" />
        </svg>
        <span class="text-[#ff6900ff] font-['inter'] font-semibold text-[13px] leading-[20px] whitespace-nowrap">
          {{ selectedLocationName }}
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[12px] h-[12px] text-[#ff6900ff] shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
        </svg>
      </button>

      <div #profileContainer class="relative flex flex-row shrink-0 justify-end items-center gap-[8px]">
        <div class="flex flex-col shrink-0 justify-center items-end">
          <span class="shrink-0 justify-start items-start text-[#000000ff] avatar text-center font-medium font-['inter'] text-[14px] leading-[22px]">
            {{ staffInfo.staffName }}
          </span>
          <span class="formatTime justify-start items-start text-[#737780ff] avatar text-center font-medium font-['inter'] text-[12px] leading-[19px]">
            Login at {{ formatTime(staffInfo?.lastLogin) }}
          </span>
        </div>
        <button
          type="button"
          class="flex flex-col shrink-0 rounded-[1000px] justify-center items-center bg-[#d0d1d4ff] w-[40px] h-[40px] border-0 cursor-pointer"
          (click)="toggleProfileMenu($event)"
          (keydown.enter)="toggleProfileMenu($event)"
          aria-label="Open profile menu">
          <span class="text-[#ffffffff] avatar text-center font-medium font-['inter'] text-[20px] leading-[32px]">
            {{ staffInfo.staffName.charAt(0) }}
          </span>
        </button>
        <div
          #profileDropdown
          *ngIf="showProfileMenu"
          class="absolute right-0 top-full mt-2 w-48 bg-white rounded-lg shadow-lg border z-50">
          <div class="py-2">
            <div
              class="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
              (click)="onLogout()"
              (keydown.enter)="onLogout()"
              tabindex="0">
              <NiIcon icon="logout" iconClass="!w-[1.5rem] !h-[1.5rem]" />
              <span class="text-gray-700 font-archivo font-bold">Logout</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>

<app-location-selection-modal
  [isOpen]="showLocationSwitcher"
  [locations]="switchLocations"
  [allowCancel]="true"
  [title]="'Switch Center'"
  [description]="'Choose the center you are working at. You stay signed in.'"
  [continueLabel]="'Switch'"
  [initialLocationId]="selectedLocationId"
  (locationSelected)="onLocationSwitchConfirmed($event)"
  (cancelled)="onLocationSwitchCancelled()"
></app-location-selection-modal>

<NiFormToaster
  *ngFor="let toast of toasts"
  [message]="toast.message"
  [type]="toast.type"
  [position]="toast.position || 'top-right'"
  (onClose)="toasterService.remove(toast.id)"
></NiFormToaster>
